import type { BallEntity, DrawContextLike } from './exitTypes'

export interface ExitPolicy {
  onGateOpened(ctx: DrawContextLike): void
  allowExit(ball: BallEntity, ctx: DrawContextLike): boolean
  assistTowardExit?(ball: BallEntity, ctx: DrawContextLike): void
  resolveNumber(ball: BallEntity, ctx: DrawContextLike): number
}

export class PhysicsResultPolicy implements ExitPolicy {
  onGateOpened(): void {}

  allowExit(): boolean {
    return true
  }

  resolveNumber(ball: BallEntity): number {
    return ball.number
  }
}

export class ResultDrivenPolicy implements ExitPolicy {
  onGateOpened(): void {}

  allowExit(ball: BallEntity, ctx: DrawContextLike): boolean {
    return ctx.targetNumber == null || ball.number === ctx.targetNumber
  }

  assistTowardExit(ball: BallEntity, ctx: DrawContextLike): void {
    if (ctx.targetNumber != null && ball.number === ctx.targetNumber) {
      ctx.nudgeBallTowardExit?.(ball.id)
    }
  }

  resolveNumber(ball: BallEntity, ctx: DrawContextLike): number {
    return ctx.targetNumber ?? ball.number
  }
}

export function createExitPolicy(mode: 'physics_result' | 'result_driven'): ExitPolicy {
  return mode === 'result_driven' ? new ResultDrivenPolicy() : new PhysicsResultPolicy()
}
